export default "__VITE_ASSET__eTyB_ZyN__"